import React from 'react';
import { Droppable, Draggable } from "react-beautiful-dnd";
import ListingCard from '../Components/ListingCard';
import { useSelector } from 'react-redux';

const Listing = ({ id }) => {
    const listings_data = useSelector((state) => state.webpage_detail.listings);

    return (
        <Droppable droppableId={id} type="LISTINGS" >
            {(provided) => {
                return (
                    <div ref={provided.innerRef}>
                        {listings_data.listings_data?.listings?.map((item, index) => {
                            return (
                                <Draggable
                                    key={`listing-${index}`}
                                    draggableId={`listing-${index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div>
                                            <div ref={provided.innerRef} {...provided.draggableProps} className={`col-12 bottom_margin`}>
                                                <ListingCard item={item} index={index} provided={provided} />
                                            </div>
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                );
            }}
        </Droppable>
    )
}

export default Listing;